@switch (state()) {
  @case (State.Empty) {
    <ng-content select="[empty]" />
  }
  @case (State.DragOver) {
    <ng-content select="[dragOver]" />
  }
  @case (State.Uploaded) {
    <ng-content select="[uploaded]" />
  }
  @case (State.Error) {
    <ng-content select="[error]" />
  }
  @case (State.Uploading) {
    <rt-spinner />
  }
}

<input
  #fileInput
  type="file"
  [accept]="accept()"
  [attr.multiple]="multiple() || null"
  (dragend)="onDragLeave()"
  (dragover)="onDragOver()"
  (dragleave)="onDragLeave()"
  (change)="handleChange(getFileFromEvent($event))"
  (keydown.enter)="$event.preventDefault()"
/>
